var map = {
	"./BarsIcon.vue": 1879,
	"./CheckmarkIcon.vue": 8530,
	"./DownloadAppStoreIcon.vue": 2689,
	"./DownloadGooglePlayIcon.vue": 5295,
	"./FacebookIcon.vue": 5192,
	"./GptIcon.vue": 3777,
	"./InstagramIcon.vue": 9904,
	"./MagnifyIcon.vue": 2653,
	"./PawIcon.vue": 5672,
	"./PawMobileIcon.vue": 4331,
	"./PinterestIcon.vue": 5462,
	"./StarIcon.vue": 1347,
	"./TwitterIcon.vue": 3611,
	"./UsersIcon.vue": 1073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2515;